import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var getDataAttributes = function getDataAttributes(dataAttributes) {
  if (!dataAttributes) {
    return {};
  }

  var dataProps = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, dataAttributes.action && {
    'data-action': dataAttributes.action
  }), dataAttributes.objectId && {
    'data-object-id': dataAttributes.objectId
  }), dataAttributes.objectType && {
    'data-object-type': dataAttributes.objectType
  }), dataAttributes.componentType && {
    'data-component-type': dataAttributes.componentType
  });

  return dataProps;
};

var getLabelClasses = function getLabelClasses(args) {
  var _args$allowLineBreaks = args.allowLineBreaks,
      allowLineBreaks = _args$allowLineBreaks === void 0 ? false : _args$allowLineBreaks,
      borderCurve = args.borderCurve,
      _args$bordered = args.bordered,
      bordered = _args$bordered === void 0 ? false : _args$bordered,
      className = args.className,
      label = args.label;
  return _formatClassName(['generic-label', "border-curve-".concat(borderCurve), {
    'has-label': Boolean(label)
  }, {
    bordered: bordered
  }, {
    'allow-line-breaks': allowLineBreaks
  }, className]);
};

var getIconClasses = function getIconClasses(args) {
  var _args$fontWeight = args.fontWeight,
      fontWeight = _args$fontWeight === void 0 ? 'normal' : _args$fontWeight,
      type = args.type,
      _args$iconColor = args.iconColor,
      iconColor = _args$iconColor === void 0 ? 'gray' : _args$iconColor,
      _args$iconPosition = args.iconPosition,
      iconPosition = _args$iconPosition === void 0 ? 'left' : _args$iconPosition;
  return _formatClassName(["generic-label-icon", "generic-label-icon-".concat(iconColor), "generic-label-font-".concat(fontWeight), "generic-label-".concat(type), "generic-label-icon-".concat(iconPosition)]);
};

export { getDataAttributes, getIconClasses, getLabelClasses };